import {useQuery} from 'react-query';
import {getTenant} from './calls';

export const useTenant = () => useQuery('TENANT', () => getTenant());